"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var areColorsEqual_1 = __importDefault(require("../utils/areColorsEqual"));
var meetsContrast_1 = require("../utils/meetsContrast");
/**
 * Returns the action color (background.click.base) unless action fallback to white or black.
 * In that case returns block.base.
 */
function getIllustrationColor(theme) {
    var backgroundColor = theme.backgroundColor, font = theme.font, block = theme.block, palette = theme.palette;
    if (!backgroundColor || !font || !block || !palette) {
        return { color: '', isLight: false, isDark: false };
    }
    var isLight = block.isLight, isDark = block.isDark;
    var action = backgroundColor.click.base;
    var isActionFallback = (0, areColorsEqual_1.default)(action, font.color.base);
    // Attempt to select the action color.
    if (action &&
        !isActionFallback &&
        !(0, areColorsEqual_1.default)(palette.secondary, block.base) &&
        !(isDark && !(0, meetsContrast_1.meetsContrast)(action, '#FFFFFF', 1.5))) {
        return { color: action, isLight: isLight, isDark: isDark };
    }
    // Edge case handling for white on white and black on black, and black on white scenarios
    if ((0, areColorsEqual_1.default)(palette.secondary, block.base) || (0, areColorsEqual_1.default)(palette.secondary, font.color.base)) {
        return { color: block.accent, isLight: isLight, isDark: isDark };
    }
    return { color: block.base, isLight: isLight, isDark: isDark };
}
exports.default = getIllustrationColor;
//# sourceMappingURL=getIllustrationColor.js.map